<!--
 * @Description: 
 * @Date: 2020-11-10 16:25:22
 * @LastEditors: jml
 * @LastEditTime: 2020-11-10 16:34:30
-->
<template>
  <div class="bi-common-title">
    <div class="icon"></div>
    <span>{{ title }}</span>
    <div class="icon"></div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      default: '',
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.bi-common-title {
  font-size: 28px;
  font-weight: bold;
  color: #000000;
  line-height: 1;
  margin-bottom: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 23px;
    &::before {
      content: '';
      width: 180px;
      height: 2px;
      background-color: #1c1c1c;
    }
    &::after {
      content: '';
      width: 9px;
      height: 9px;
      border-radius: 100%;
      border: 2px solid #1c1c1c;
    }
    &:last-child {
      transform: rotateY(180deg);
    }
  }
}
</style>
